export const sharedBucketlistConstants= {
    GET_BUCKET_LIST_BY_MENTOR_ACTION_REQUEST:
      "GET_BUCKET_LIST_BY_MENTOR_ACTION_REQUEST",
    GET_BUCKET_LIST_BY_MENTOR_ACTION_SUCCESS:
      "GET_BUCKET_LIST_BY_MENTOR_ACTION_SUCCESS",
    GET_BUCKET_LIST_BY_MENTOR_ACTION_FAILURE:
      "GET_BUCKET_LIST_BY_MENTOR_ACTION_FAILURE",

  };
  